export enum EStatus {
  PENDING = 'PENDENTE',
  COMPLETED = 'CONCLUÍDO',
  RELEASED = 'CARGA LIBERADA'
}
